import React, { Component } from "react";
import $ from 'jquery';
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight, faLocationDot, faPhone, faClock} from "@fortawesome/free-solid-svg-icons";

export default class ItemSucursal extends Component {


    constructor(props) {
        super(props);
        this.handleClick = this.cardHandleClick.bind(this);
    }

    selectCardSucursal(nombreSucursal) {
        //limpiar cards
        $("div[name=card-sucursal]").removeClass("text-white bg-success");
        $("div[name=card-sucursal] [name=btn-gps]").removeClass("btn-cu-secundary");
        $("div[name=card-sucursal] [name=btn-gps]").addClass("btn-cu-primary");

        //pintar card seleccionada
        $(`div[sucursal-name="${nombreSucursal}"]`).addClass("text-white bg-success");
        $(`div[sucursal-name="${nombreSucursal}"]`).find("[name=btn-gps]").removeClass("btn-cu-primary");
        $(`div[sucursal-name="${nombreSucursal}"]`).find("[name=btn-gps]").addClass("btn-cu-secundary");

        document.querySelector(`div[sucursal-name="${nombreSucursal}"]`).scrollIntoView();

    }

    cardHandleClick(e, coordenadas) {

        //limpiar cards
        $("div[name=card-sucursal]").removeClass("text-white bg-success");
        $("div[name=card-sucursal] [name=btn-gps]").removeClass("btn-cu-secundary");
        $("div[name=card-sucursal] [name=btn-gps]").addClass("btn-cu-primary");

        //pintar card seleccionada
        $(e.target).closest("div[name=card-sucursal]").addClass("text-white bg-success");
        $(e.target).closest("div[name=card-sucursal]").find("[name=btn-gps]").removeClass("btn-cu-primary");
        $(e.target).closest("div[name=card-sucursal]").find("[name=btn-gps]").addClass("btn-cu-secundary");

        this.props.clickCard(coordenadas, 14);
    }

    redirigirAMapa(origen, destino) {
        let url = `https://www.google.com/maps/dir/?api=1&origin=${origen.toString()}&destination=${destino.toString()}&travelmode=driving`;
        window.open(url, "_blank");
    }

    mapHorarios(horario, index) {
        return <span key={index}>{horario}<br /></span>;
    }

    filterTelefonos(value, index) {
        return index < 2;
    }

    render() {

        const { sucursal, ubicacionActual } = this.props;
        const coordenadas = [sucursal.latitud, sucursal.longitud];

        return (

            <div name="card-sucursal" sucursal-name={sucursal.nombreSucursal} className="list-group-item list-group-item-action sucursal-item" onClick={(e) => { this.cardHandleClick(e, coordenadas) }}>
               
                    <div className="row">
                        <div className="col-md-9">
                        <h6 style={{fontSize:"18px", fontWeight:"bold", marginBottom:"1rem"}}>{sucursal.nombreSucursal}</h6>

                        </div>
                        <div className="col-md-3">
                        <label style={{fontSize:"15px" }}>{parseFloat(sucursal.distancia).toFixed(2) + " Km."}</label>
                        </div>
                    </div>
                    
                
                <div className="container">
                <div className="row">
                <div className="col-12" style={{display:"flex", margin:"0.2rem 0"}}>
                <FontAwesomeIcon style={{paddingRight:"0.6rem" }} icon={faLocationDot} /> <p className="mb-1"> {sucursal.direccion}</p>
                </div>
                </div>
                <div className="row"> 
                <div className="col-12" style={{display:"flex", margin:"0.2rem 0"}}>
                <FontAwesomeIcon style={{paddingRight:"0.6rem" }} icon={faClock} /> <p className="mb-1">{sucursal.horario.map(this.mapHorarios)}</p>
                </div>
                </div>
                <div className="row">
                <div className="col-12" style={{display:"flex" , margin:"0.2rem 0"}}> 
                <FontAwesomeIcon style={{paddingRight:"0.6rem" }} icon={faPhone} /><p className="mb-1">{sucursal.telefonos.filter(this.filterTelefonos).join(" | ")} </p>
                </div>
                </div>

                </div>
                <div className="col-md-12">
                <button name="btn-gps" className="btn btn-sm btn-cu-primary btn-llegar" style={{width:"50%" }} onClick={(e) => this.redirigirAMapa(ubicacionActual, coordenadas)}>
                     Cómo llegar <FontAwesomeIcon icon={faArrowRight}/>
                </button>
                </div>
               
            </div>

        )
    }
}